<section class="fixed flex justify-center items-center top-2 left-5 right-5 z-[4000]">
  <div class="relative gap-2 flex flex-col justify-center w-full items-center">
    @for (toast of toasts(); track toast.id) {
      <div
        [@slideInOut]
        class="flex w-full justify-center items-center top-2 left-5 right-5 p-4 rounded-xl shadow"
        [class.bg-green-300]="toast.type === ToastTypeEnum.SUCCESS"
        [class.bg-red-300]="toast.type === ToastTypeEnum.ERROR"
      >
        <div class="flex justify-between items-center w-full">
          <div class="flex items-center gap-3">
            @if (toast.type === ToastTypeEnum.SUCCESS) {
              <app-icon
                color="var(--blue)"
                path="assets/icons/check-circle.svg"
              />
            } @else if (toast.type === ToastTypeEnum.ERROR) {
              <app-icon
                color="var(--blue)"
                path="assets/icons/warning-circle.svg"
              />
            }

            <span class="text-blue font-medium text-lg">{{ toast.message }}</span>
          </div>

          <div class="rounded overflow-hidden">
            <app-close-button (close)="deleteToast(toast.id)" />
          </div>
        </div>
      </div>
    }
  </div>
</section>
